/* Planer IKEA -> zestaw (sekcja planer-zestaw). Link z planera -> usługa na laptopie -> lista frontów, podgląd 3D
   i link ?zestaw=. Usługa: POST /plan {link} -> {status, id}; GET /plan/<id> co 3 s aż „gotowe” albo „blad”
   (serwer_planu.py; błędy z polem „kod”, kolejka z „eta_s” - oba opcjonalne). Styl i kolor wybrane pod podglądem
   trafiają do linku (common w zestawie z1) i do podglądu 3D; kafelki stylów rysuje KnfFront (knf-front.js) jak
   w konfiguratorze. „Pełna wycena mailem” wpisuje link do formularza na tej samej stronie. */
(() => {
  const T = {
    pl: {
      busy1: "Otwieramy Twój projekt w planerze IKEA…", busy2: "Czytamy szafki i fronty…", busy_queue: "Czekasz w kolejce…",
      queue: "Przed Tobą: %N (około %M min)", wait: "Zwykle trwa to około minuty.", pcs: "%N szt.",
      aux: "Pokaż panele, blendy i cokoły z planu (%N\u00a0szt.)", opis3d: "Podgląd 3D kuchni z Twojego planu",
      err_link: "To nie jest link do zapisanego projektu w planerze kuchni IKEA. Skopiuj link z przycisku Udostępnij.",
      err_off: "Nie udało się odczytać projektu. Wyślij link w formularzu powyżej, a przygotujemy wycenę.",
      err_dlugo: "To trwa dłużej niż zwykle. Kliknij Pokaż fronty jeszcze raz za kilka minut.",
      err_3d: "Podgląd 3D nie wczytał się w tej przeglądarce. Lista frontów poniżej jest kompletna.",
      wpisany: "Link jest już w formularzu.",
      err: { planer: "Planer IKEA nie oddał projektu. Sprawdź, czy link jest z przycisku Udostępnij, albo wyślij go w formularzu powyżej.",
             brak_frontow: "W tym projekcie nie znaleźliśmy szafek kuchennych METOD z frontami. Jeśli to szafa PAX albo inna zabudowa, wyślij link w formularzu powyżej, a przygotujemy wycenę.",
             nieznane: "Spróbuj jeszcze raz - kliknij Pokaż fronty.",
             limit_ip: "Z tej sieci sprawdzono już dużo projektów. Spróbuj za godzinę albo wyślij link w formularzu powyżej.",
             kolejka: "Mamy teraz dużo zapytań. Spróbuj za kilka minut albo wyślij link w formularzu powyżej." },
      mail: "Proszę o pełną wycenę frontów do mojego projektu z planera IKEA.", mail_link: "Link do projektu: ", mail_styl: "Styl frontów: ", mail_kolor: "Kolor frontów: ", mail_sklep: "Sklep: ",
      types: { "Drzwi": "Drzwi", "Szuflada": "Szuflada", "Front zmywarki bez nawiertów": "Front zmywarki", "Drzwi narożne": "Drzwi łamane A+B",
               "Cargo": "Cargo", "Panele boczne": "Panel boczny", "Blenda": "Blenda", "Cokoły": "Cokół" },
      uchylne: "Drzwi uchylne do góry",
      styl_dol: "Styl z uchwytem wybierz już tutaj - wtedy fronty nad blatem dostaną w konfiguratorze uchwyt na dole.",
      c: { bez_frontow: "Szafki %S cm bez frontów w planie: %N szt. Frontów do nich nie ma w zestawie ani w cenie - dobierzemy je w pełnej wycenie.",
           z_gniazd: "Fronty odtworzone z szafek IKEA, bo nie ma ich w planie: %N szt. Sprawdź ich podział w konfiguratorze albo poproś o pełną wycenę.",
           z_modelu: "Wymiary części frontów (%N szt.) odczytaliśmy z modelu 3D. Sprawdź je w konfiguratorze.",
           skrocony: "%Y: w planie ma ponad 240 cm. W zestawie ma 240 cm (największy wymiar w konfiguratorze). Jeśli potrzebujesz dłuższego, poproś o pełną wycenę.",
           gniazdo_bez_wymiaru: "Jednego frontu nie da się odczytać z planu. Uzupełnimy go w wycenie.",
           uchwyt: "Nie wiemy, na jakiej wysokości są niektóre drzwi szafek wysokich (%N szt.). W konfiguratorze sprawdź „Lokalizacja uchwytu” - drzwi nad blatem zwykle mają „Dół”." }
    },
    de: {
      busy1: "Wir öffnen Ihr Projekt im IKEA-Planer…", busy2: "Wir lesen Schränke und Fronten aus…", busy_queue: "Sie sind in der Warteschlange…",
      queue: "Vor Ihnen: %N (etwa %M Min.)", wait: "Das dauert meist etwa eine Minute.", pcs: "%N Stk.",
      aux: "Seitenpaneele, Blenden und Sockel aus dem Plan anzeigen (%N\u00a0Stk.)", opis3d: "3D-Ansicht der Küche aus Ihrem Plan",
      err_link: "Das ist kein Link zu einem gespeicherten Projekt im IKEA-Küchenplaner. Kopieren Sie den Link über „Teilen“ im Planer.",
      err_off: "Wir konnten das Projekt nicht lesen. Senden Sie uns den Link über das Formular oben, dann erstellen wir Ihnen ein Angebot.",
      err_dlugo: "Das dauert länger als üblich. Klicken Sie in ein paar Minuten noch einmal auf „Fronten anzeigen“.",
      err_3d: "Die 3D-Ansicht konnte in diesem Browser nicht geladen werden. Die Frontenliste unten ist vollständig.",
      wpisany: "Der Link steht schon im Formular.",
      err: { planer: "Wir konnten das Projekt im IKEA-Planer nicht öffnen. Prüfen Sie, ob Sie den Link über „Teilen“ kopiert haben, oder senden Sie ihn über das Formular oben.",
             brak_frontow: "In diesem Projekt haben wir keine METOD-Küchenschränke mit Fronten gefunden. Wenn es ein PAX-Schrank oder ein anderes Möbelstück ist, senden Sie den Link über das Formular oben, dann erstellen wir Ihnen ein Angebot.",
             nieznane: "Bitte versuchen Sie es noch einmal - klicken Sie auf „Fronten anzeigen“.",
             limit_ip: "Aus diesem Netzwerk wurden schon viele Projekte geprüft. Versuchen Sie es in einer Stunde noch einmal oder senden Sie den Link über das Formular oben.",
             kolejka: "Gerade gibt es viele Anfragen. Versuchen Sie es in ein paar Minuten oder senden Sie den Link über das Formular oben." },
      mail: "Bitte um ein vollständiges Angebot für die Fronten zu meinem Projekt aus dem IKEA-Planer.", mail_link: "Link zum Projekt: ", mail_styl: "Frontstil: ", mail_kolor: "Frontfarbe: ", mail_sklep: "Shop: ",
      types: { "Drzwi": "Tür", "Szuflada": "Schubladenfront", "Front zmywarki bez nawiertów": "Geschirrspülerfront", "Drzwi narożne": "Falttür A+B",
               "Cargo": "Cargo", "Panele boczne": "Seitenpaneel", "Blenda": "Blende", "Cokoły": "Sockel" },
      uchylne: "Klappe (nach oben öffnend)",
      styl_dol: "Wählen Sie einen Stil mit Griff schon hier - dann haben Fronten über der Arbeitsplatte den Griff unten.",
      c: { bez_frontow: "Schränke %S cm ohne Fronten im Plan: %N Stk. Die Fronten dafür sind weder im Set noch im Preis enthalten - wir ergänzen sie im Angebot.",
           z_gniazd: "Aus den IKEA-Schränken ergänzte Fronten, die im Plan fehlen: %N Stk. Prüfen Sie die Aufteilung im Konfigurator oder fordern Sie ein vollständiges Angebot an.",
           z_modelu: "Die Maße einiger Fronten (%N Stk.) stammen aus dem 3D-Modell. Bitte prüfen Sie sie im Konfigurator.",
           skrocony: "%Y: Im Plan ist es länger als 240 cm. Im Set hat es 240 cm (das Höchstmaß im Konfigurator). Brauchen Sie es länger, fordern Sie ein vollständiges Angebot an.",
           gniazdo_bez_wymiaru: "Eine Front lässt sich aus dem Plan nicht lesen. Wir ergänzen sie im Angebot.",
           uchwyt: "Wir wissen nicht, in welcher Höhe einige Türen der Hochschränke sitzen (%N Stk.). Prüfen Sie im Konfigurator die „Griffposition“ - für Türen über der Arbeitsplatte passt meist „Unten“." }
    },
    en: {
      busy1: "Opening your design in the IKEA planner…", busy2: "Reading cabinets and fronts…", busy_queue: "You're in the queue…",
      queue: "Ahead of you: %N (about %M min)", wait: "This usually takes about a minute.", pcs: "%N pcs", pc1: "pc",
      aux: "Show side panels, fillers and plinths from your plan (%N\u00a0pcs)", opis3d: "3D view of the kitchen from your plan",
      err_link: "This isn't a link to a saved design in the IKEA kitchen planner. Copy the link from the Share button.",
      err_off: "We couldn't read the design. Send the link using the form above and we'll prepare a quote.",
      err_dlugo: "This is taking longer than usual. Click Show my fronts again in a few minutes.",
      err_3d: "The 3D view couldn't load in this browser. The list of fronts below is complete.",
      wpisany: "The link is already in the form.",
      err: { planer: "We couldn't open your design in the IKEA planner. Check that you copied the link from Share, or send it using the form above.",
             brak_frontow: "We didn't find any METOD kitchen cabinets with fronts in this design. If it's a PAX wardrobe or other furniture, send the link using the form above and we'll prepare a quote.",
             nieznane: "Please try again - click Show my fronts.",
             limit_ip: "Many designs have already been checked from this network. Try again in an hour or send the link using the form above.",
             kolejka: "We're getting a lot of requests right now. Try again in a few minutes or send the link using the form above." },
      mail: "Please send me a full quote for the fronts in my IKEA planner design.", mail_link: "Link to the design: ", mail_styl: "Front style: ", mail_kolor: "Front colour: ", mail_sklep: "Shop: ",
      types: { "Drzwi": "Door", "Szuflada": "Drawer front", "Front zmywarki bez nawiertów": "Dishwasher front", "Drzwi narożne": "Bi-fold doors A+B",
               "Cargo": "Cargo", "Panele boczne": "Side panel", "Blenda": "Filler", "Cokoły": "Plinth" },
      uchylne: "Lift-up door",
      styl_dol: "Choose a style with a handle here - then the fronts above the worktop get their handle at the bottom.",
      c: { bez_frontow: "%S cm cabinets with no fronts in your plan: %N pcs. Their fronts aren't in the set or the price - we'll add them in the full quote.",
           z_gniazd: "Fronts worked out from the IKEA cabinets because the plan doesn't include them: %N pcs. Check the layout in the configurator or ask for a full quote.",
           z_modelu: "Some front sizes (%N pcs) come from the 3D model. Please check them in the configurator.",
           skrocony: "%Y: it's longer than 240 cm in your plan. The set has it at 240 cm (the configurator's maximum). If you need it longer, ask for a full quote.",
           gniazdo_bez_wymiaru: "We couldn't read one front from your plan. We'll add it in the quote.",
           uchwyt: "We don't know how high some of the tall cabinet doors sit (%N pcs). In the configurator, check “Handle location” - for doors above the worktop it's usually “Bottom”." }
    }
  };
  // link także ze środka tekstu (udostępnianie z telefonu); do usługi idzie postać kanoniczna
  const LINK_RE = /https:\/\/kitchen\.planner\.ikea\.com\/([a-z]{2})\/([a-z]{2})\/planner\/([0-9a-f-]{36})/i;
  const POLL_MS = 3000, MAX_MS = 180000, KLUCZ = "pz-planer";
  const KONF = typeof DecompressionStream === "function";   // konfigurator czyta zestaw z1 przez DecompressionStream (brak w Safari < 16.4)

  function init(root) {
    if (root.dataset.pzInit) return;
    root.dataset.pzInit = "1";
    const api = (root.dataset.api || "").replace(/\/+$/, "");
    const t = T[root.dataset.jez] || T.pl;
    const $ = s => root.querySelector(s);
    const form = $("[data-pz-form]"), input = $("[data-pz-link]"), go = $("[data-pz-go]"), err = $("[data-pz-err]");
    const busy = $("[data-pz-busy]"), busyTxt = $("[data-pz-busy-txt]"), busySub = $("[data-pz-busy-sub]");
    const result = $("[data-pz-result]"), tytul = $(".pz__res-title"), open = $("[data-pz-open]"), full = $("[data-pz-full]");
    const v3 = $("[data-pz-3d]"), view = $("[data-pz-3d-view]"), czekaj3d = $(".pz__3d-wait"), hint3d = $(".pz__3d-hint");
    let run = 0, lastLink = "", lastId = "", linkNr = 0;
    const dane = (k, d) => { try { return JSON.parse(root.dataset[k] || d); } catch (e) { return JSON.parse(d); } };
    const kolory = dane("kolory", "[]"), style = dane("style", "[]"), TEX = dane("tex", "{}"), DREWNO = dane("drewno", "{}");
    let kolor = kolory[0] || null, kolorKlienta = false, widok = null, wynik = null;   // kolorKlienta: klient sam wybrał próbkę
    let styl = style.find(s => s.n === "Gładki") || style[0] || { n: "Gładki", l: "Gładki", k: "lakier", g: 18 }, stylKlienta = false;
    let dol = false;   // zestaw z wyniku ma fronty z „Lokalizacja uchwytu: Dół” (fronty nad blatem)

    // %S bez wymiaru i %Y bez typu wypadają z tekstu; „1 pcs” -> „1 pc”
    const fmt = (s, o) => {
      if (o.s == null) s = s.replace(/%S cm ?/, "");
      if (!o.y) s = s.replace(/%Y: ?/, "");
      s = s.replace("%N", () => o.n ?? "").replace("%S", () => o.s).replace("%M", () => o.m ?? "").replace("%Y", () => o.y);
      if (t.pc1) s = s.replace(/(^|[^\d])1(\s)pcs\b/g, (m, a, sp) => a + "1" + sp + t.pc1);
      return s.charAt(0).toUpperCase() + s.slice(1);
    };
    const cm = mm => { const v = Math.round((mm + 3) / 10); return v; };              // front METOD: 597 -> 60
    const cmAux = mm => Math.round(mm / 10);                                            // panele, blendy: 618 -> 62
    const tekst = (el, s) => { if (el.textContent !== s) el.textContent = s; };       // bez zmian region statusu nie ogłasza się od nowa
    function showErr(msg, doFormularza) {
      if (msg && doFormularza && doWyceny(false)) msg += " " + t.wpisany;
      err.textContent = msg; err.hidden = !msg;
      if (msg) err.scrollIntoView({ block: "nearest" });
    }
    function pokazStatus(d) {
      const wKolejce = d.status === "w_kolejce" && d.pozycja > 1;
      tekst(busyTxt, d.status === "w_toku" ? t.busy2 : wKolejce ? t.busy_queue : t.busy1);
      tekst(busySub, wKolejce ? fmt(t.queue, { n: d.pozycja - 1, m: Math.max(1, Math.ceil((d.eta_s > 0 ? d.eta_s : d.pozycja * 50) / 60)) }) : t.wait);
    }
    function setBusy(on) {
      // region statusu jest stale w DOM; tekst wpisujemy po pokazaniu ramki, żeby czytnik ekranu go ogłosił
      if (on && document.activeElement === go) input.focus({ preventScroll: true });   // wyłączony przycisk zrzuciłby fokus na body
      go.disabled = on; input.readOnly = on;
      busy.classList.toggle("is-on", on);
      if (on) requestAnimationFrame(() => { if (busy.classList.contains("is-on") && !busyTxt.textContent) pokazStatus({}); });
      else { busyTxt.textContent = ""; busySub.textContent = ""; }
    }
    function li(name, dims, qty) {
      const el = document.createElement("li");
      const a = document.createElement("span"), d = document.createElement("span");
      a.append(name + " "); d.className = "pz__dim"; d.textContent = dims; a.append(d);
      const b = document.createElement("span"); b.textContent = fmt(t.pcs, { n: qty });
      el.append(a, b); return el;
    }
    function konfiguratorUrl(link) {
      // zestaw zawsze w sklepie, na którym jest klient (waluta i język tej domeny), od razu pod adresem konfiguratora w tym
      // języku (data-knf): przekierowanie /products/front-ikea -> uchwyt DE oddawało 12.10 zestaw z pamięci (cudzy)
      try { const u = new URL(link); return location.origin + (root.dataset.knf || u.pathname) + u.search; } catch (e) { return link; }
    }
    // zestaw z1 = base64url(deflate-raw(JSON knf:set)); podmieniamy wygląd w common
    const b64 = {
      od: s => Uint8Array.from(atob(s.replace(/-/g, "+").replace(/_/g, "/") + "=".repeat((4 - s.length % 4) % 4)), ch => ch.charCodeAt(0)),
      do: u => btoa(String.fromCharCode(...u)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")
    };
    const przez = async (u, strumien) => new Uint8Array(await new Response(new Blob([u]).stream().pipeThrough(strumien)).arrayBuffer());
    // common jak zaleca konfigurator: styl i kolor polską nazwą z metapola (inna nazwa = po cichu Biel Klasyczna),
    // drewno bez koloru i wykończenia, grubość standardowa stylu (Linea i Hampton 19 mm)
    async function zWygladem(link, { styl: n, kat, kolor: k }) {
      try {
        const u = new URL(link), z = u.searchParams.get("zestaw") || "";
        if (!n || !z.startsWith("z1.") || !window.CompressionStream) return link;
        const d = JSON.parse(new TextDecoder().decode(await przez(b64.od(z.slice(3)), new DecompressionStream("deflate-raw"))));
        const drewno = kat !== "lakier", s = style.find(x => x.n === n) || {};
        d.common = { ...d.common, styl: n, kolor: drewno ? "" : k || d.common.kolor, custom: "", strona: "Jednostronnie",
          wyk: drewno ? "" : "Pół-mat", sloje: drewno ? "Nie" : "", grubosc: (s.g || 18) + " mm", grubAdd: { nd: null, fr: null } };
        // konfigurator live rozpoznaje „ten sam link” po długości i 24 ostatnich znakach z: skrót wyglądu na końcu JSON
        // zmienia koniec zestawu, ten sam wybór daje ten sam link (konfigurator ignoruje nieznane pole)
        if (window.crypto && crypto.subtle) { const h = new Uint8Array(await crypto.subtle.digest("SHA-256", new TextEncoder().encode(n + "|" + d.common.kolor))); d.wyg = [...h.slice(0, 16)].map(x => x.toString(16).padStart(2, "0")).join(""); }
        u.searchParams.set("zestaw", "z1." + b64.do(await przez(new TextEncoder().encode(JSON.stringify(d)), new CompressionStream("deflate-raw"))));
        return u.toString();
      } catch (e) { return link; }
    }
    // czy w zestawie jest linia z uchwytem na dole (zestaw_link.py: opt „Lokalizacja uchwytu”); bez dekodera nie
    async function zDolem(link) {
      try {
        const z = new URL(link).searchParams.get("zestaw") || "";
        const d = JSON.parse(new TextDecoder().decode(await przez(b64.od(z.slice(3)), new DecompressionStream("deflate-raw"))));
        return (d.set || []).some(l => l.opt && l.opt["Lokalizacja uchwytu"] === "Dół");
      } catch (e) { return false; }
    }
    function zapisz() {   // powrót z konfiguratora: link, zlecenie, wybrany styl i kolor do końca sesji karty
      try { sessionStorage.setItem(KLUCZ, JSON.stringify({ link: lastLink, id: lastId, k: kolorKlienta && kolor ? kolor.n : "", s: stylKlienta ? styl.n : "" })); } catch (e) { /* bez sessionStorage */ }
    }
    async function ustawLink() {
      open.dataset.pzCzeka = "1";   // klik w przycisk czeka na nowy link
      const w = wynik, my = ++linkNr, href = konfiguratorUrl(await zWygladem(w.link_zestawu, { styl: styl.n, kat: styl.k, kolor: kolor && kolor.n }));
      if (w !== wynik || my !== linkNr) return;   // szybkie kliknięcia: obowiązuje ostatni wybór
      open.href = href;
      delete open.dataset.pzCzeka;
      const f = document.querySelector(".wyc__fork");   // baner „Otwórz konfigurator” formularza wyceny też z zestawem
      if (f) { if (!f.dataset.pzHref) f.dataset.pzHref = f.getAttribute("href"); f.href = href; }
      if (wpisano) doWyceny(false);   // formularz już wypełniony: nadąża za zmianą stylu i koloru
      if (lastId) zapisz();
    }
    const sw = $("[data-pz-kolory]"), stw = $("[data-pz-style]"), opisDrewna = $("[data-pz-drewno-opis]");
    // kolor albo (fornir, sklejka) opis palety z metapola zamiast próbek, jak w konfiguratorze
    function pokazKolor() {
      const drewno = styl.k !== "lakier", d = DREWNO[styl.k] || {};
      sw.hidden = drewno; $("[data-pz-kolor-pref]").hidden = drewno;
      $("[data-pz-kolor-nazwa]").textContent = drewno ? d.l || "" : kolor ? kolor.l : "";
      opisDrewna.textContent = drewno ? d.o || "" : ""; opisDrewna.hidden = !opisDrewna.textContent;
    }
    function wybierzKolor(c) {
      kolor = c;
      [...sw.children].forEach((b, i) => { b.setAttribute("aria-checked", String(kolory[i] === c)); b.tabIndex = kolory[i] === c ? 0 : -1; });
      pokazKolor(); rysujKafelki();
      if (widok) widok.kolor(c.h);
      if (wynik) ustawLink();
    }
    // kafelki stylów: ten sam rysunek co w konfiguratorze (renderTiles w knf-rysunek.js), lakier w bieżącym kolorze,
    // drewno z miniatury skanu; nazwa stylu w języku strony, do linku idzie polska
    const kat = n => (style.find(s => s.n === n) || {}).k || "lakier";
    function rysujKafelki() {
      if (!window.KnfFront) return;
      [...stw.querySelectorAll(".pz__st")].forEach((b, i) => {
        const s = style[i];
        if (s.k !== "lakier" && b.dataset.pzRys) return;      // drewno nie zależy od koloru
        const { defs, g } = KnfFront.svg({ style: s.n, hex: kolor ? kolor.h : "#ECEBE6", loc: "Góra", hinge: "", horiz: false, gloss: false, customOn: false, locCustom: false },
          597, 797, 917 / 56, `knf-t${i}-`, { tex: TEX, cat: kat });
        b.querySelector("svg").innerHTML = `<defs>${defs}</defs><rect x="14" y="20" width="597" height="797" fill="#000" opacity=".06"/>${g}`;
        b.dataset.pzRys = "1";
      });
    }
    // pod kafelkami: styl z uchwytem - w konfiguratorze trzeba wybrać stronę zawiasów; styl bez uchwytu, a w zestawie fronty
    // z „Dół” - zachęta do stylu z uchwytem (konfigurator w stylu bez uchwytu usuwa jego lokalizację). Uwaga „uchwyt” z usługi
    // (drzwi szafek wysokich o nieznanej wysokości) tylko w stylach z uchwytem.
    function pokazUwagiStylu() {
      const z = $("[data-pz-zawiasy]"); z.textContent = styl.u ? z.dataset.t : wynik && dol ? t.styl_dol : "";
      const u = $("[data-pz-checklist] [data-pz-uchwyt]");
      if (u) { u.hidden = !styl.u; $("[data-pz-check]").hidden = !$("[data-pz-checklist] li:not([hidden])"); }
    }
    function wybierzStyl(s) {
      styl = s;
      [...stw.querySelectorAll(".pz__st")].forEach((b, i) => { b.setAttribute("aria-checked", String(style[i] === s)); b.tabIndex = style[i] === s ? 0 : -1; });
      $("[data-pz-styl-nazwa]").textContent = s.l;
      pokazUwagiStylu();
      pokazKolor();
      if (widok) widok.ustaw({ styl: s.n, kat: s.k });
      if (wynik) ustawLink();
    }
    style.sort((a, b) => (a.k !== "lakier") - (b.k !== "lakier"));   // grupy Lakierowane i Drewno, w grupie kolejność z metapola
    [["lakier", stw.dataset.tLakier], ["drewno", stw.dataset.tDrewno]].forEach(([g, tytul]) => {
      const grupa = style.filter(s => (s.k === "lakier") === (g === "lakier"));
      if (!grupa.length) return;
      const el = document.createElement("div"), h = document.createElement("p"), k = document.createElement("div");
      el.className = "pz__sgr"; h.className = "pz__sgr-t"; h.textContent = tytul; k.className = "pz__sgr-k";
      if (g === "lakier") { const p = document.createElement("span"); p.className = "pz__sgr-hint"; p.textContent = stw.dataset.tHint; h.append(p); }   // telefon: rząd przewija się w bok
      el.append(h, k); stw.append(el);
      grupa.forEach(s => {
        const b = document.createElement("button"), n = document.createElement("span");
        b.type = "button"; b.className = "pz__st"; b.title = s.l; b.tabIndex = -1;
        b.setAttribute("role", "radio"); b.setAttribute("aria-label", s.l);
        b.innerHTML = '<svg viewBox="-120 -60 837 917" aria-hidden="true" focusable="false"></svg>';
        n.className = "pz__st-n"; n.textContent = s.l; b.append(n);
        b.addEventListener("click", () => { stylKlienta = true; wybierzStyl(s); });
        b.addEventListener("mouseenter", () => { $("[data-pz-styl-nazwa]").textContent = s.l; });   // komputer: nazwa pod kursorem
        b.addEventListener("mouseleave", () => { $("[data-pz-styl-nazwa]").textContent = styl.l; });
        k.append(b);
      });
    });
    stw.addEventListener("keydown", e => {      // radiogroup: jeden przystanek Tab, wybór strzałkami
      const n = style.length, i = style.indexOf(styl);
      const j = { ArrowRight: i + 1, ArrowDown: i + 1, ArrowLeft: i - 1, ArrowUp: i - 1, Home: 0, End: n - 1 }[e.key];
      if (j === undefined || !n) return;
      e.preventDefault();
      stylKlienta = true; wybierzStyl(style[(j + n) % n]); stw.querySelectorAll(".pz__st")[(j + n) % n].focus();
    });
    kolory.forEach(c => {
      const b = document.createElement("button");
      b.type = "button"; b.className = "pz__sw"; b.title = c.l; b.tabIndex = -1;
      b.style.setProperty("--c", c.h);
      b.setAttribute("role", "radio"); b.setAttribute("aria-label", c.l);
      b.addEventListener("click", () => { kolorKlienta = true; wybierzKolor(c); });
      sw.append(b);
    });
    sw.addEventListener("keydown", e => {       // radiogroup: jeden przystanek Tab, wybór strzałkami
      const n = kolory.length, i = kolory.indexOf(kolor);
      const j = { ArrowRight: i + 1, ArrowDown: i + 1, ArrowLeft: i - 1, ArrowUp: i - 1, Home: 0, End: n - 1 }[e.key];
      if (j === undefined || !n) return;
      e.preventDefault();
      kolorKlienta = true; wybierzKolor(kolory[(j + n) % n]); sw.children[(j + n) % n].focus();
    });
    if (kolor) wybierzKolor(kolor);
    wybierzStyl(styl);
    $("[data-pz-kolory-wrap]").hidden = !kolory.length;
    $("[data-pz-style-wrap]").hidden = !style.length;
    if (!KONF) {      // bez dekodera zestawu konfigurator pokazałby pusty koszyk: główną akcją jest pełna wycena
      open.hidden = true; $("[data-pz-kolory-info]").hidden = true;
      full.classList.remove("pz__btn--ghost"); full.classList.add("pz__btn--wide"); open.after(full);
    }

    // „Pełna wycena mailem”: link do formularza na tej stronie. Formularz wyceny v3 (data-wyc-planer): link, styl i kolor.
    // Formularz kontaktowy Horizon (contact[body]): prośba, link, styl i kolor (gdy klient je wybrał) i domena + ukryte pola.
    // W formularzu v3 styl to kafelek grupy (Gładki, Frezowany, Fornir, Sklejka - stałe wartości z KONTRAKT.md §1), styl
    // frezowany dokładnie w uwagach, a przy drewnie w polu koloru nazwa stylu. Po zmianie wyboru formularz nadąża, ale
    // nadpisujemy tylko to, co sami wpisaliśmy (v3), nigdy tekstu klienta.
    // NIE wpisywać nagłówka „ZGLOSZENIE Z FORMULARZA WYCENY”: taki mail bierze worker automatu i bez pełnego bloku
    // z KONTRAKT.md §1 odkłada go do Konrada. Zwraca false, gdy formularza nie ma.
    const nasze = { styl: "", kolor: "", uwagi: "" };   // ostatnio wpisane przez stronę do formularza v3
    let wpisano = false;
    const formularz = () => document.querySelector("[data-wyc-planer]") || document.querySelector('textarea[name="contact[body]"]');
    const wpisz = (el, v) => { el.value = v; el.dispatchEvent(new Event("input", { bubbles: true })); el.dispatchEvent(new Event("change", { bubbles: true })); };
    // nasz blok w polu tekstowym: poprzedni podmieniamy (albo usuwamy), bez dublowania; tekst klienta zostaje
    const podmien = (el, stare, nowe) => {
      const v = el.value.trim(), w = stare && v.includes(stare) ? v.replace(stare, () => nowe).trim() : nowe && v ? nowe + "\n\n" + v : nowe || v;
      if (w !== el.value) wpisz(el, w);
    };
    function ukryte(f, name, value) {
      let el = [...f.querySelectorAll('input[type="hidden"]')].find(x => x.name === name);
      if (!value) { if (el) el.remove(); return; }
      if (!el) { el = document.createElement("input"); el.type = "hidden"; el.name = name; f.append(el); }
      el.value = value;
    }
    function doWyceny(przewin) {
      const pole = formularz(), sty = stylKlienta ? styl : null, kol = kolorKlienta && styl.k === "lakier" ? kolor : null;
      if (!pole || !lastLink) return false;
      const zPl = x => x.l === x.n ? x.n : `${x.l} (${x.n})`;
      if (pole.matches("[data-wyc-planer]")) {
        if (pole.value !== lastLink) wpisz(pole, lastLink);
        const f = pole.form, k = f && f.querySelector('[name="contact[Kolor]"]'), u = f && f.querySelector("[data-wyc-body]");
        const grupa = sty && (sty.n === "Gładki" ? "Gładki" : { lakier: "Frezowany", fornir: "Fornir", sklejka: "Sklejka" }[sty.k]);
        const r = f && grupa && [...f.querySelectorAll('[name="contact[Styl]"]')].find(x => x.value === grupa);
        const zazn = f && f.querySelector('[name="contact[Styl]"]:checked');
        if (r && (!zazn || zazn.value === nasze.styl)) {
          if (r !== zazn) { r.checked = true; r.dispatchEvent(new Event("change", { bubbles: true })); }
          nasze.styl = grupa;
        }
        const kt = kol ? kol.l : sty && sty.k !== "lakier" ? sty.l : "";
        if (k && (k.value === nasze.kolor || (kt && !k.value.trim()))) { if (k.value !== kt) wpisz(k, kt); nasze.kolor = kt; }
        if (u) { const ut = grupa === "Frezowany" ? t.mail_styl + zPl(sty) : ""; podmien(u, nasze.uwagi, ut); nasze.uwagi = ut; }
      } else {
        const linie = [t.mail, t.mail_link + lastLink];
        if (sty) linie.push(t.mail_styl + zPl(sty));
        if (kol) linie.push(t.mail_kolor + zPl(kol));
        linie.push(t.mail_sklep + location.host);
        // nasz blok rozpoznajemy po treści (linia t.mail i kolejne do pustej), nie po pamięci JS: działa też w polu
        // odtworzonym przez przeglądarkę i gdy klient poprawił blok; nasze linie bieżące, linie klienta z bloku pod nimi
        const L = pole.value.split("\n"), i = L.indexOf(t.mail);
        if (i < 0) podmien(pole, "", linie.join("\n"));
        else {
          let j = i + 1;
          while (j < L.length && L[j].trim()) j++;
          L.splice(i, j - i, ...linie, ...L.slice(i + 1, j).filter(x => ![t.mail_link, t.mail_styl, t.mail_kolor, t.mail_sklep].some(p => x.startsWith(p))));
          if (L.join("\n") !== pole.value) wpisz(pole, L.join("\n"));
        }
        if (pole.form) {
          // długi link zestawu (0,7-0,9 tys. znaków) w ukrytym polu: Shopify dopisuje pola contact[...] do maila
          ukryte(pole.form, "contact[Zrodlo]", "Planer IKEA");
          ukryte(pole.form, "contact[Zestaw w konfiguratorze]", wynik ? open.href : "");
        }
      }
      if (przewin) { pole.scrollIntoView({ behavior: "smooth", block: "center" }); setTimeout(() => pole.focus({ preventScroll: true }), 400); }
      wpisano = true;
      return true;
    }

    function render(w, przewin) {
      wynik = w;
      if (widok) { widok.zniszcz(); widok = null; }
      const KOL = ["Drzwi", "Cargo", "Szuflada", "Front zmywarki bez nawiertów", "Drzwi narożne", "Panele boczne", "Blenda", "Cokoły"];
      const kol = p => (KOL.indexOf(p.typ) + 1 || 99) * 1e8 - p.wys_mm * 1e4 - p.szer_mm;   // typ, potem od największych
      const fr = w.pozycje.filter(p => !p.pomocnicze).sort((a, b) => kol(a) - kol(b));
      const aux = w.pozycje.filter(p => p.pomocnicze).sort((a, b) => kol(a) - kol(b));
      const sztuk = arr => arr.reduce((s, p) => s + p.qty * (p.specjalne === "para_AB" ? 2 : 1), 0);
      const ul = $("[data-pz-fronty]"); ul.replaceChildren();
      fr.forEach(p => {
        const dims = p.specjalne === "para_AB" ? "25×80 cm" : `${cm(p.szer_mm)}×${cm(p.wys_mm)} cm`;
        ul.append(li(p.uchylne ? t.uchylne : (t.types[p.typ] || p.typ), dims, p.qty * (p.specjalne === "para_AB" ? 2 : 1)));
      });
      $("[data-pz-count]").textContent = "· " + fmt(t.pcs, { n: sztuk(fr) });
      const auxUl = $("[data-pz-aux]"); auxUl.replaceChildren();
      aux.forEach(p => auxUl.append(li(t.types[p.typ] || p.typ, `${cmAux(p.szer_mm)}×${cmAux(p.wys_mm)} cm`, p.qty)));
      $("[data-pz-aux-wrap]").hidden = !aux.length;
      $("[data-pz-aux-sum]").textContent = fmt(t.aux, { n: sztuk(aux) });
      // uwagi: bez notatki z planu (szum z IKEA, zostaje dla wyceny) i bez „pomocnicze” (zdanie jest w liście paneli);
      // szafki bez frontów razem po szerokości
      const uwagi = [];
      (w.do_sprawdzenia || []).forEach(c => {
        if (!t.c[c.kod]) return;
        const g = c.kod === "bez_frontow" && uwagi.find(u => u.kod === c.kod && u.szer_cm === c.szer_cm);
        if (g) g.n += c.n || 1;
        else uwagi.push(c.kod === "bez_frontow" ? { ...c, n: c.n || 1 } : c);
      });
      const cl = $("[data-pz-checklist]");
      cl.replaceChildren(...uwagi.map(c => {
        const el = document.createElement("li"); el.textContent = fmt(t.c[c.kod], { n: c.n, s: c.szer_cm, y: t.types[c.typ] || c.typ });
        if (c.kod === "uchwyt") el.dataset.pzUchwyt = "";   // widoczna tylko w stylach z uchwytem (pokazUwagiStylu)
        return el;
      }));
      $("[data-pz-check]").hidden = !uwagi.length;
      dol = false; pokazUwagiStylu();
      zDolem(w.link_zestawu).then(v => { if (wynik === w) { dol = v; pokazUwagiStylu(); } });
      open.href = konfiguratorUrl(w.link_zestawu);
      const f0 = formularz();   // pole odtworzone przez przeglądarkę (Wstecz po wygaśnięciu bfcache) z naszym blokiem: dalej nadąża
      if (!wpisano && f0 && !f0.matches("[data-wyc-planer]") && f0.value.split("\n").includes(t.mail)) wpisano = true;
      ustawLink();
      full.hidden = !formularz();
      result.hidden = false; form.hidden = true;
      const st = stw.querySelector('[aria-checked="true"]');   // styl z sesji może być poza widocznym rzędem kafelków
      if (st) stw.scrollLeft = Math.max(0, st.offsetLeft - stw.offsetLeft - 24);
      if (przewin) { result.scrollIntoView({ behavior: "smooth", block: "start" }); tytul.focus({ preventScroll: true }); }
      // podgląd 3D: style, kolory i lista działają bez niego; przy błędzie zostaje komunikat w miejscu podglądu
      const sc = w.scena && (w.scena.bryly || []).length && window.PlanerZestaw3D ? w.scena : null;
      v3.hidden = !sc;
      if (sc) {
        view.classList.remove("pz__3d-view--err"); view.replaceChildren(czekaj3d); hint3d.hidden = false;
        PlanerZestaw3D.pokaz(view, sc, { kolor: kolor ? kolor.h : undefined, styl: styl.n, kat: styl.k, tex: TEX, opis: t.opis3d })
          .then(h => { if (wynik === w) { widok = h; h.ustaw({ kolor: kolor && kolor.h, styl: styl.n, kat: styl.k }); } else h.zniszcz(); })   // wybór w trakcie ładowania
          .catch(() => { if (wynik !== w) return; view.classList.add("pz__3d-view--err"); view.textContent = t.err_3d; hint3d.hidden = true; });
      }
    }
    async function call(path, opts = {}) {
      // GET bez Content-Type: zapytanie „proste”, bez preflight CORS przy każdym odpytaniu
      // limit 20 s na zapytanie: zawieszone połączenie (laptop zasnął, sieć zgubiona) nie trzyma kręciołka bez końca
      const o = opts.body ? { ...opts, headers: { "Content-Type": "application/json" } } : { ...opts };
      if (window.AbortSignal && AbortSignal.timeout) o.signal = AbortSignal.timeout(20000);
      const r = await fetch(api + path, o);
      let d = {}; try { d = await r.json(); } catch (e) { /* pusta odpowiedź */ }
      return { http: r.status, ...d };
    }
    // błąd dla klienta (tekst z T); doFormularza: link trafia też do formularza wyceny na tej stronie
    const blad = (msg, doFormularza) => Object.assign(new Error(msg), { pz: true, doFormularza });
    async function start(link) {
      const my = ++run;
      input.removeAttribute("aria-invalid");
      showErr(""); result.hidden = true; setBusy(true);
      if (window.PlanerZestaw3D && PlanerZestaw3D.zaladuj) PlanerZestaw3D.zaladuj().catch(() => {});   // three.js w czasie czekania
      const wyslij = async () => {
        const d = await call("/plan", { method: "POST", body: JSON.stringify({ link }) });
        if (d.http === 400) throw d.kod === "zapytanie" ? blad(t.err_off, true) : blad(t.err_link);
        if (d.http === 429) throw blad(t.err[d.kod] || t.err.kolejka, true);
        return d;
      };
      try {
        let d = await wyslij(), ponow = 1, klucz = "", t0 = Date.now(), bledySieci = 0;
        while (my === run && d.status !== "gotowe") {
          if (d.status === "blad") {
            if (d.kod === "nieznane" && ponow-- > 0) { d = await wyslij(); continue; }   // usługa po restarcie nie zna zlecenia
            throw d.kod === "nieznane" ? blad(t.err.nieznane) : blad(t.err[d.kod] || t.err.planer, true);
          }
          if (!d.id) throw blad(t.err_off, true);
          // limit liczony od ostatniej zmiany statusu albo miejsca w kolejce, nie od kliknięcia
          if (d.status) { const k = d.status + ":" + (d.pozycja || 0); if (k !== klucz) { klucz = k; t0 = Date.now(); } }
          if (Date.now() - t0 > MAX_MS) throw blad(t.err_dlugo, true);
          if (d.status) pokazStatus(d);
          await new Promise(r => setTimeout(r, POLL_MS));
          if (my !== run) return;
          // chwilowy błąd sieci przy odpytywaniu (Wi-Fi/LTE, uśpiona karta): ponów przy kolejnym odpytaniu, d to ostatnia
          // dobra odpowiedź, więc MAX_MS dalej ogranicza czekanie
          try { d = { id: d.id, ...(await call("/plan/" + d.id)) }; bledySieci = 0; }
          catch (e) { if (my !== run) return; if (++bledySieci > 4) throw e; }
        }
        if (my !== run) return;
        if (!d.wynik || !Array.isArray(d.wynik.pozycje)) throw blad(t.err_off, true);
        setBusy(false); lastId = d.id || ""; render(d.wynik, true);
      } catch (e) {
        if (my !== run) return;
        setBusy(false);
        showErr(e && e.pz ? e.message : t.err_off, !e || !e.pz || e.doFormularza);   // wyjątki JS i sieci: ogólny tekst
      }
    }

    form.addEventListener("submit", ev => {
      ev.preventDefault();
      const m = input.value.match(LINK_RE);
      if (!m) { input.setAttribute("aria-invalid", "true"); showErr(t.err_link); input.focus(); return; }
      const link = `https://kitchen.planner.ikea.com/${m[1].toLowerCase()}/${m[2].toLowerCase()}/planner/${m[3].toUpperCase()}/`;
      input.value = link; lastLink = link; start(link);
    });
    $("[data-pz-again]").addEventListener("click", () => {
      run++; result.hidden = true; form.hidden = false; input.readOnly = false; input.value = ""; showErr(""); input.focus();
      if (widok) { widok.zniszcz(); widok = null; }
      wynik = null; lastId = "";
      try { sessionStorage.removeItem(KLUCZ); } catch (e) { /* bez sessionStorage */ }
      const f = document.querySelector(".wyc__fork[data-pz-href]"); if (f) f.href = f.dataset.pzHref;
    });
    full.addEventListener("click", () => doWyceny(true));
    // klik zaraz po wyborze stylu albo koloru czeka na nowy link (najwyżej 2 s); klik z modyfikatorem jak zwykły link
    open.addEventListener("click", e => {
      if (!open.dataset.pzCzeka || e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      let n = 0; const idz = () => open.dataset.pzCzeka && n++ < 40 ? setTimeout(idz, 50) : location.assign(open.href); idz();
    });

    // powrót z konfiguratora (Wstecz bez bfcache): wynik z usługi (trzyma go 30 min), bez przewijania
    try {
      const z = JSON.parse(sessionStorage.getItem(KLUCZ) || "null");
      if (z && z.link && z.id) {
        input.value = lastLink = z.link; lastId = z.id;
        const k = kolory.find(c => c.n === z.k); if (k) { kolorKlienta = true; wybierzKolor(k); }
        const s = style.find(x => x.n === z.s); if (s) { stylKlienta = true; wybierzStyl(s); }
        call("/plan/" + encodeURIComponent(z.id)).then(d => {
          if (!run && !wynik && input.value === z.link && d.status === "gotowe" && d.wynik && Array.isArray(d.wynik.pozycje)) render(d.wynik, false);
          else if (!run && !wynik && input.value === z.link && d.status === "blad") {   // wynik wygasł: klient klika jeszcze raz
            showErr(t.err.nieznane);
            // przewinięcie sprzed wyjścia przywraca przeglądarka albo motyw (Horizon scroll-container.js) już po showErr
            const pokaz = () => setTimeout(() => { if (!err.hidden) err.scrollIntoView({ block: "center", behavior: "instant" }); }, 600);
            if (document.readyState === "complete") pokaz(); else addEventListener("load", pokaz, { once: true });
            // pole odtworzone przez przeglądarkę z naszym blokiem: ukryte pola jak przy wyniku; bez bloku nic nie wpisujemy
            const f = formularz();
            if (f && !f.matches("[data-wyc-planer]") && f.value.split("\n").includes(t.mail)) doWyceny(false);
          }
        }).catch(() => {});
      }
    } catch (e) { /* bez sessionStorage */ }
  }

  document.querySelectorAll("[data-pz]").forEach(init);
  document.addEventListener("shopify:section:load", e => e.target.querySelectorAll("[data-pz]").forEach(init));
})();
